@if (isSessionTimeoutStatus) {
    <show-message [type]="messageType.INFO">
        <div info>
            <strong>{{ 'PARTY.CASHIER.web.session.timeout.nl.header' | translate }}</strong>
            <p [vnDynamicHtml]="'PARTY.CASHIER.web.session.timeout.nl.message' | translate: { url: sessionTimeUpdateUrl }"></p>
        </div>
    </show-message>
}
